/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';

/**
 * The SCV invalid parameter type.
 */
export type EntityScvInvalidParam = io.TypeOf<typeof ScvInvalidParam>;

/**
 * The SCV invalid parameter definition.
 */
export const ScvInvalidParam = io.type({
  name: io.string,
  reason: io.string,
});

/**
 * The SCV error response type.
 * @export
 */
export type EntityScvErrorResponse = io.TypeOf<typeof ScvErrorResponse>;

/**
 * The SCV error response definition.
 * @export
 */
export const ScvErrorResponse = io.intersection(
  [
    io.partial({
      'invalid-params': io.array(ScvInvalidParam),
    }),
    io.type({
      status: io.number,
      title: io.string,
    }),
  ],
  `ScvErrorResponse`,
);
